import React from 'react';

import { SsoCallback } from 'src/components/auth/SsoCallback/SsoCallback';

export const SsoCallbackPage: React.FC = () => {
  return <SsoCallback />;
};
